let inactivityTimer;

const resetInactivityTimer = (onTimeout, timeout = 30 * 60 * 1000) => {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(onTimeout, timeout);
};

export const setupInactivityTimeout = (onTimeout, timeout) => {
  const events = ['mousemove', 'keydown', 'scroll', 'click'];
  const reset = () => resetInactivityTimer(onTimeout, timeout);

  events.forEach(event => window.addEventListener(event, reset));
  reset(); // initial timer

  return () => {
    clearTimeout(inactivityTimer);
    events.forEach(event => window.removeEventListener(event, reset));
  };
};
